import InitialInfo from "./content/initial-info.jsx";
import ScheduleDates from "./content/schedule-dates.jsx";
import AttendancesTable from "./content/attendances-table.jsx";
import Attachments from "./content/attachments.jsx";
import {makeFactAddressItems} from "./helpers/fact-address-items.js";
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";

const hasItems = (items) => Array.isArray(items) && items.length > 0;

export default function ReportContent({ data, printOptions }) {
    const schedule = data?.schedule ?? {};

    const sections = {
        attendances: hasItems(schedule?.attendance_list),
        attachment: hasItems(schedule?.attachment),
    }

    return (
        <div className="space-y-4">
            <InitialInfo title="DADOS INICIAIS" data={data} printOptions={printOptions} />

            <ScheduleDates title="AGENDAMENTO" data={data} />

            <InfoGrid title={"ENDEREÇO DO FATO"} items={makeFactAddressItems(data)} columns={2} />

            {sections.attendances && (
                <AttendancesTable title="ATENDIMENTOS REALIZADOS" data={data} />
            )}

            {sections.attachment && (
                <Attachments title="ANEXOS" data={data} printOptions={printOptions} />
            )}
        </div>
    )
}
